import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class HttpCancelService {
	private readonly whitelistedUrls = ['/api/siteClaims/menu-items'];

	private readonly pendingHttpRequests$ = new Subject<void>();

	public cancelPendingRequests(): void {
		this.pendingHttpRequests$.next();
	}

	public onCancelPendingRequests(url: string): Observable<void> {
		return this.pendingHttpRequests$.pipe(filter(() => !this.isUrlWhitelisted(url)));
	}

	public isUrlWhitelisted(url: string): boolean {
		return this.whitelistedUrls.includes(url);
	}
}
